import React, { Fragment } from "react";

const Button = props => {
  return (
    <Fragment>
      <button
        className="custom_btn"
        onClick={props.exportPDF}
        style={{ marginLeft: props.marginLeft }}
      >
        {props.spinner ? (
          <i
            className="fa fa-spinner fa-pulse fa-fw"
            style={{ color: "#fff" }}
          ></i>
        ) : null}
        Download PDF{" "}
        <i className="fa fa-arrow-down bounce" aria-hidden="true"></i>
      </button>
    </Fragment>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/parts/pdfmaker/common/Button.jsx